const initialCustomization = () => {
	return {
		name: '',
		isCustom: true,
		isFixedPrice: true,
		isAvailable: true,
		options: [
			{
				name: '',
				price: 0,
				ingredient: null,
				isAvailable: true,
			},
		],
	}
}

const initialCustomizationOptions = () => {
	return {
		name: '',
		price: 0,
		ingredient: null,
		isAvailable: true,
	}
}

export default {
	initialCustomization: initialCustomization,
	initialCustomizationOptions: initialCustomizationOptions,
	dish: {
		customizations: function () {
			return {
				selected: [],
				custom: [],
			}
		},
	},
}
